import { InputSwitchModule } from 'primeng/inputswitch';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { first } from 'rxjs';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnFarmMiService } from 'src/app/services/on-farm-mi.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-past-subsidy-data',
  templateUrl: './past-subsidy-data.component.html',
  styleUrls: ['./past-subsidy-data.component.scss']
})
export class PastSubsidyDataComponent implements OnInit {

  isSubmitted = false;
  applicationId: any = null;
  userID: any;

  formData: FormGroup;
  farmerPreviousSubsidies: any = [];

  constructor(
    public router: Router,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService,
    private _fb: FormBuilder,
    private ofService: OnFarmMiService,
    private _dashboardService: DashboardService,
  ) { }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.formData = this._fb.group({
      aadharNo: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(12)]],
    });
  }

  get formDataControls() {
    return this.formData.controls;
  }

  getApplicationStatus() {
    if (this.formData.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Enter Aadhar No.',
      });
      return;
    }
    console.log(this.formData.value.aadharNo);
    this.getApplicationNo(this.formData.value.aadharNo);

    this.isSubmitted = true;
  }

  getApplicationNo(aadharNo) {
    this.loader.start();
    this.deptDashBoardService
      .getAppIdByAadharNo(aadharNo)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.applicationId = data[0][0]?.APP_ID;
          this.checkApplicationDetails(this.applicationId);
        },
        error: (err) => {
          this.loader.close();
          this.isSubmitted = false;

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  checkApplicationDetails(appId) {
    this.getApplicationDetails(appId)
  }

  getPastSubsidiesByFarmerId(farmerID) {
    // if (this.farmerId) {
    // this.loader.start();
    this.ofService
      .GetFarmerPastSubsidyByFarmerId(farmerID)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if(data.length != 0){
            this.farmerPreviousSubsidies = data;
          }else {
            this.messageService.add({
            severity: 'info',
            summary: 'Info Message',
            detail:   `No Previous Subsidies found corresponding to the Aadhar No. ${this.formData.value.aadharNo}`,
          });
          }
          // this.loader.close();
        },
        error: () => {
          this.farmerPreviousSubsidies = [];
          this.isSubmitted = false;
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Previous Subsidies not loaded.',
          });
        },
      });
  }

  getApplicationDetails(appId) {
    this.loader.start();
    this._dashboardService.getApplicationByAppId(appId).pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res) {
            let farmerId = res.Farmer_ID;
            if (farmerId) {
              this.getPastSubsidiesByFarmerId(farmerId);
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'OOPs!!! Something went wrong.',
              });
            }
          }
        },
        error: () => {
          this.loader.close();
          this.isSubmitted = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Previous Subsidies not loaded.',
          });
        },
      });
  }

  onClear(){
    this.isSubmitted = false;
    this.formData.reset();
    this.farmerPreviousSubsidies = [];
  }
}
